<template>
  <div class="order-list-container">
    <!-- 订单列表表单项 -->
    <el-card class="order-card none" :class="{refund_num: !userInfo.company }" :body-style="{ padding: '0' }" shadow="never">
      <div class="refund-wrap" v-if="refundNum">
        <img class="refund-icon" :src="`${$ossUrl}icon-notice.png`" alt="">
        <span v-if="isKnowRefund" class="refund-content">您有{{refundNum}}笔退款中的订单，如申请退款时间超过{{allNumber.autoRefundDay}}个自然日未处理，则系统将自动退款， <span @click="handleRefundNow" style="color: #3377FF; cursor: pointer;">立即处理</span></span>
        <span v-else class="refund-content">您有{{refundNum}}笔退款中的订单，<span @click="handleRefundNow" style="color: #3377FF cursor: pointer;">立即处理</span></span>
      </div>
      <div class="refund-wrap" v-if="invoiceNum && !userInfo.company">
        <img class="refund-icon" :src="`${$ossUrl}icon-notice.png`" alt="">
        <span class="refund-content">您有{{invoiceNum}}条开票申请，<a style="color: #de2f2f;text-decoration: underline" @click="invoicing">点击此处</a>去处理</span>
      </div>
      <div class="refund-wrap">
        <img class="refund-icon" :src="`${$ossUrl}icon-notice.png`" alt="">
        <span class="refund-content">车队与企服订单由平台统一开票给车主，请不要开票给车主</span>
      </div>
    </el-card>
    <el-card>
      <el-radio-group v-model="businessType" @change="tabChange">
        <template v-for="item in tabList">
          <el-radio-button v-if="item.show" :key="item.code" :label="item.code">{{item.label}}</el-radio-button>
        </template>
      </el-radio-group>
    </el-card>
    <el-card class="order-card" shadow="never">
      <!-- <img src="https://companydir-1304574412.cos.ap-beijing.myqcloud.com/1.mp4?ci-process=snapshot&time=1" alt=""> -->
      <el-form :inline="true" label-position="right" label-width="85px" :model="orderOptions" size="small" ref='orderOptions' class="demo-form-inline order-form">
        <el-form-item label="订单号：" prop="orderId">
          <el-input v-model="orderOptions.orderId" placeholder="请输入订单号" suffix-icon="xxxx">
            <el-select v-model="orderOptions.queryOrderType" slot="prepend" placeholder="请选择" style="width:90px;">
              <el-option label="油品" :value="0"></el-option>
              <el-option label="非油品" :value="1"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="orderOptions.phone" placeholder="请输入11位手机号" suffix-icon="xxxx" :maxlength="11" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单状态：" prop="orderPayFlag">
          <el-select v-model="orderOptions.orderPayFlag" clearable placeholder="全部状态">
            <el-option label="全部状态" :value="''"></el-option>
            <el-option v-for="(value, key) in orderPayFlags" :label="value" :value="Number(key)" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="油站：" class="order-options-item" prop="gasId">
          <el-select v-model="orderOptions.gasId" clearable filterable placeholder="全部油站" @change="val => gasId = val" >
            <el-option label="全部油站" :value="''">
            </el-option>
            <el-option v-for="item in gasList" :label="item.gasName"  :value="item.gasId" :key="item.gasId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="枪号：" prop="gunNo" v-if="!isShowguns">
          <el-input v-model="orderOptions.gunNo" placeholder="请输入数字" suffix-icon="xxxx" clearable></el-input>
        </el-form-item>
        <el-form-item label="枪号：" prop="guns" v-else>
          <!-- <el-input  v-model="orderOptions.gunNo" placeholder="请输入数字" suffix-icon="xxxx" clearable></el-input> -->
          <el-select v-model="orderOptions.guns" multiple placeholder="请选择" @change="handleChangeGun" collapse-tags clearable>
            <el-option value="all">全部</el-option>
            <el-option
              v-for="item in optionsGunNo"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="油号：" prop="oilNo">
          <el-select v-model="orderOptions.oilNo" clearable placeholder="请选择油号">
            <el-option label="请选择油号" :value="''"></el-option>
            <el-option v-for="item in oilNumList" :label="item.oilNum" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <el-tooltip class="item" effect="light" content="清洁燃料请选择普通油号进行筛选，比如E92#，请选择92#" placement="right">
            <i class="el-icon-question" style="margin-top: 7px;"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="支付方式：">
          <el-select v-model="orderOptions.payType" clearable filterable placeholder="请选择">
            <el-option value="" label="全部"></el-option>
            <el-option v-for="item in payTypeList" :key="item.payTypeCode" :label="item.payTypeName" :value="item.payTypeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址：">
          <address-select ref="address" v-model="address" :zoom="3" filterable></address-select>
        </el-form-item>
        <el-form-item label="下单时间：">
          <el-date-picker
            size="small"
            v-model="checkoutTime"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            unlink-panels
            align="right"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="(val) => onChangePayTime(val,'checkoutTime','orderDtStart','orderDtEnd')">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付时间：">
          <el-date-picker
            size="small"
            v-model="payTime"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            unlink-panels
            align="right"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="(val) => onChangePayTime(val,'payTime','payDtStart','payDtEnd')">
          </el-date-picker>
        </el-form-item>
        <template v-if="businessType === ''">
          <el-form-item label="开票方：" class="order-options-item" prop="invoiceFlags">
            <el-select v-model="orderOptions.invoiceFlags" clearable placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in partyList" :label="item.label"  :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="开票状态：" class="order-options-item" prop="oilInvoiceStatus" v-if="showInvoiceStatusButton">
            <el-select v-model="orderOptions.oilInvoiceStatus" clearable placeholder="全部">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in invoiceStatusList" :label="item.label"  :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item> -->
        </template>
        <el-form-item label="结算模式：" class="order-options-item" prop="orderSettleType" label-width="150px">
          <el-select v-model="orderOptions.orderSettleType" clearable placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="抖音模式结算" :value="1"></el-option>
            <el-option label="抖音原生核销" :value="-1001"></el-option>
            <el-option label="其他" :value="0"></el-option>
          </el-select>
          <el-tooltip class="item" effect="light" content="抖音结算模式：在团油抖音小程序完成交易的订单，以及使用了在团油抖音小程序售卖的商家券的订单，将独立按D+3结算模式，并将商家券的售卖金额一并结算给您" placement="right">
            <i class="el-icon-question" style="margin-top: 7px;"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <div class="g-flex-c">
        <el-button class="btn" style="width: 70px;" size="mini" type="primary" @click="query('check')">查询</el-button>
        <el-button style="width: 70px" size="mini" @click="resetForm" >重置</el-button>
        <!-- <el-button style="width: 70px" size="mini" @click="onExportExcel" :loading="exportLoading">导出</el-button> -->
        <download-button style="width: 70px" :downloadApi="exportData" :queryParams="queryParams" @countPoint="$track.clickEvent('团油订单导出', '1621011390')"></download-button>
      </div>
    </el-card>
    <!-- 订单列表汇总项 -->
    <el-card v-if="!isHongQi" class="order-card"  v-loading="isAllLoading" shadow="never">
      <div class="card">
        <card title="交易总金额" width="24%" unit="元" :num="allNumber.allGunAmount | formatMoney" back='linear-gradient(225deg, #81A5FF 0%, #4B7EFE 100%)' :isOrder="true"/>
        <card title="实付总金额" width="24%" unit="元" :num="allNumber.allPayAmount | formatMoney" back='linear-gradient(225deg, #B7C5DC 0%, #8394B3 100%)' v-if="showRealAmount" :isOrder="true"/>
        <card title="订单数量" width="24%" unit="单" :num="allNumber.orderTotal | formatMoney" back='linear-gradient(225deg, #ECD39E 0%, #D6A75B 100%)' :isOrder="true"/>
        <card :title="isGas === 2 ? '总数量' : '总升数'" width="24%" :unit="isGas === 2 ? '' : '升'" :num="allNumber.allLitre | formatMoney" back='linear-gradient(225deg, #B3B2DA 0%, #7578B4 100%)' :isOrder="true"/>
      </div>
    </el-card>
    <!-- 展示退款订单数 -->
    <div class="show_refund show_refund_end">
      <el-button class="setBtn" @click="setDisplay" v-if="!userInfo.company">展示设置</el-button>
    </div>
    <!-- 订单列表表格 -->
    <el-card class="order-card drawer-tabel"  :body-style="{ padding: '0' }" shadow="never">
      <el-table v-loading="loading"  size="small" :data="orderData"  highlight-current-row stripe style="width: 100%">
        <template v-for="(item,index) in tableConfig" >
          <el-table-column v-if="item.slot === 'preferentialAmountMerchants'" :label="item.label" :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'> 
              <template slot-scope="scope">
                <el-popover
                  placement="right"
                  width="250"
                  trigger="hover"
                  >
                  <p>商家承担直降金额: {{scope.row.activityAmountFromMt}}</p>
                  <p>商家承担平台优惠券金额: {{scope.row.pltCouponAmountFromMt}}</p>
                  <p>商家承担商家优惠券金额: {{scope.row.merchantCouponAmount}}</p>
                  <span slot="reference" style="color: #4B7EFE; cursor: pointer">{{scope.row.preferentialAmountMerchants}}</span>
                </el-popover>
              </template>
          </el-table-column>
          <el-table-column v-else-if="item.slot === 'phone'" :label="item.label" :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'>
            <template slot-scope="scope">
              {{scope.row.phone | hidePhoneFourRank}}
            </template>
          </el-table-column>
          <template v-else-if="item.slot === 'verificateStatus'">
            <el-table-column :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'>
              <template slot-scope="scope">
                {{scope.row.verificateStatus}}
              </template>
            </el-table-column>
          </template>
          <template v-else-if="item.slot === 'orderPayFlagName'">
            <el-table-column :label="item.label" :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'>
              <template slot-scope="scope">
                <span :class="[4, 5, 6].includes(scope.row.orderPayFlag) ? 'change_color' : ''">{{scope.row.orderPayFlagName}}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column v-else-if="item.slot === 'action'" :label="item.label" :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'> 
            <template slot-scope="scope">
              <el-button-group>
                <el-button type="text" class="default table-btn" size="mini" @click="showDetail(scope.row)">详情</el-button>
                <template  v-if="scope.row.orderPayFlag === 1">
                  <template v-if="scope.row.show === 2">
                    <!--一键退款和发起退款只能有一个,showOneClickRefund字段展示权限-->
                    <el-button type="text" class="table-btn" v-if="scope.row.showOneClickRefund" size="mini" @click="showRefund(scope.row, 'one')">一键退款</el-button>
                    <el-button type="text" class="table-btn" v-else size="mini" @click="showRefund(scope.row)">发起退款</el-button>
                  </template>
                  <el-button type="text" class="table-btn" size="mini" @click="showDoc(scope.row.orderId)">补打小票</el-button>
                </template>
                <template v-if="scope.row.orderPayFlag === 4 && [1,3].includes(scope.row.show)">
                  <el-button type="text" :disabled="scope.row.show === 3" size="mini" class="table-btn" @click="confirmRefund(scope.row, scope.row.refundReason)">确认退款</el-button>
                  <el-button type="text" :disabled="scope.row.show === 3" size="mini" class="default table-btn"  @click="rejectRefund(scope.row)">拒绝退款</el-button>
                </template>
                <el-button type="text" v-if="scope.row.showInvoiceFlagButton === 0" size="mini" class="default table-btn"  @click="confirm(scope.row)">标记开票</el-button>
                <el-button type="text" v-if="scope.row.showInvoiceFlagButton === 2" size="mini" class="default table-btn"  @click="revoke(scope.row.orderId)">撤销开票</el-button>
              </el-button-group>
            </template>
          </el-table-column>
          <template v-else-if="item.slot === 'invoiceFlagName'">
            <el-table-column label="" :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'>
              <template slot="header">
                <el-tooltip class="item" effect="light" content="开票方代表该订单由谁开发票给车主" placement="top-start">
                  <span><i class="el-icon-question"></i>开票方</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="item.slot === 'oilInvoiceStatusName'">
            <el-table-column :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'>
              <template slot="header">
                <el-tooltip class="item" effect="light" content="不可开票：您可自行判断是否给车主开票" placement="top-start">
                  <span><i class="el-icon-question"></i>开票状态</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </template>
          <el-table-column v-else :label="item.label" :prop="item.prop" :min-width="item.width" :fixed="item.fixed" :key="index" align='center'></el-table-column>
        </template>
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageOptions.pageIndex"
          :page-sizes="pageSizes"
          :page-size="pageOptions.pageSize"
          :layout="isHongQi ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :total="allTotal">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog title="开票标记" :visible.sync="dialogInvoice" width="500px" >
      <p>是否标记开票？</p>
      <p>请确认该订单是否已开过发票给<span style="color: red">车主</span>,标记后将关闭退款</p>
      <p style="color:#4B7EFE; cursor: pointer;" @click="goOrder">查看该消费者历史已支付订单</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogInvoice = false">取 消</el-button>
        <el-button type="primary" @click="confirmInvoice">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 订单详情组件 -->
    <orderDetail ref="orderDetail" :address="address" :orderOptions="orderOptions" @handleDetailChange="handleDetailChange" :isGas="isGas" :orderId="orderId" :isShipStation="isShipStation" :showOilPayAmount="showOilPayAmount"></orderDetail>
    <!-- 补打小票提示组件 -->
    <ticket ref="ticket" :orderId="orderId" @handleChangeTicket="handleChangeTicket" />
    <!-- 确认退款组件 -->
    <confirmRefundDialog ref="confirmRefundDialog" :row="row" @handleConfirmRefund="handleConfirmRefund"/>
    <!--拒绝退款组件-->
    <rejectRefundDialog ref="rejectRefundDialog" :row="row" v-if="reset" @handleRejectRefund="handleRejectRefund" @cancalReject="reset = false"/>
    <!--申请退款组件-->
    <applyRefundDialog ref="applyRefund" :row="row" @handleApply="handleApply"/>
    <!-- 展示设置 -->
    <el-dialog
      :visible.sync="setDisplayVisible"
      title="订单自定义展示设置"
      :destroy-on-close="true"
      center>
      <div style="text-align: right">
        <el-button type="text" @click="useDefault" style="margin-right: 20px;">恢复默认</el-button>
      </div>
      <div class="g-flex-c">
        <el-transfer
          v-model="settingValue"
          :data="columnData"
          @change="setRightChange"
          :titles="['可选字段', '已选字段预览']"
        >
          <template slot-scope="{ option }">
            <div class="g-flex-sb">
              <span>{{ option.label }}</span>
              <span v-if="option.show && option.optional" @click="delSelected(option)"> <i class="el-icon-delete"></i> </span>
            </div>
          </template>
        </el-transfer>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSetting">取 消</el-button>
        <el-button type="primary"  @click="confirmSetting">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// orderPayFlag
// {0: "未支付", 1: "已支付", 4: "退款中", 5: "已退款", 6: "退款失败", 7: "已取消"}
import { getOrdersByPageNew, exportData, getQueryOrderType, getQueryGasList, getOilNumList, getRefundNum, getSum, showRealAmount, getColumn, saveColumn, getDefaultColumn, payTypeList, getInvoiceNum, orderPageButtonList, allGasGunOptioons, revokeInvoice, confirmInvoice, getInvoiceStatus, getInvoiceSource, showRealPayAmount } from '@/api/order'
import { gasLicenceExpiryTips, queryGasInfoCheckNotice } from '@/api/gasStationManage/gasInfo'
import { violationRecordNotice } from '@/api/ruleCenter/index'
import { exportSearchList } from '@/utils/listTools'
import orderDetail from './orderDetail'
import card from '@/components/work/card'
import addressSelect from '@/components/work/AddressSelect'
import ticket from './components/ticket'
import confirmRefundDialog from './components/confirmRefundDialog'
import rejectRefundDialog from './components/rejectRefundDialog'
import applyRefundDialog from './components/applyRefundDialog'
import moment from 'moment'
import { mapState } from 'vuex'
import { getStationEnergyType } from '@api/common'
import _ from 'lodash'

let tableConfig = [
  {label: '下单时间',prop: 'orderDt',width: 150},
  {label: '支付时间',prop: 'payDt',width: 150},
  {label: '支付方式',prop: 'payTypeName',width: 150},
  {label: '订单号',prop: 'orderId',width: 180},
  {label: '开票方',prop: 'invoiceFlagName',width: 136, slot: 'invoiceFlagName'},
  {label: '订单来源',prop: 'orderSourceName',width: 101},
  {label: '吨数',prop: 'ton',width: 80},
  {label: '枪号',prop: 'gunNo',width: 75},
  {label: '油号',prop: 'oilNumName',width: 75},
  {label: '升数',prop: 'litre',width: 75},
  {label: '加油金额（元）',prop: 'amountGun',width: 136},
  {label: '油品实付金额（元）', prop: 'onlyOilPayAmount', width: 136},
  {label: '商家优惠金额(元)',prop: 'preferentialAmountMerchants',width: 136, slot: 'preferentialAmountMerchants'},
  // {label: '结算金额(元)',prop: 'settlementAmount',width: 136},
  {label: '用户手机号',prop: 'phone',width: 136, slot: 'phone'},
  {label: '船舶名称',prop: 'shipName',width: 136},
  {label: '订单状态',prop: 'orderPayFlagName',width: 136, slot: 'orderPayFlagName'},
  {label: '开票状态',prop: 'oilInvoiceStatusName',width: 136, slot: 'oilInvoiceStatusName' },
  {label: '核销状态',prop: 'verificateStatus',width: 136, slot: 'verificateStatus'},
  {label: '所属油站',prop: 'gasName',width: 136},
  {label: '退款时间',prop: 'refundDt',width: 136},
  {label: '退款原因',prop: 'refundReason',width: 136},
  {label: '操作', prop: 'action', slot: "action", width: 250, fixed: "right"}
]
// 0: "未支付", 1: "已支付", 4: "退款中", 5: "已退款", 6: "退款失败", 7: "已取消"
export default {
  name: 'order_orderList', // 订单缓存
  data () {
    return {
      isShowguns: false, // 是否展示枪号多选择框
      optionsGunNo: [],
      exportData,
      tabList: [
        {
          label: '全部',
          code: '',
          show: true
        },
        // {
        //   label: '能链直供',
        //   code: 2,
        //   show: false
        // },
        {
          label: '能链企服',
          code: 3,
          show: false
        }
      ],
      businessType: '',
      menuCode: 'tuanyouOrder', // 固定值，用于查询表格配置
      invoiceNum: 0,
      columnData: [],
      tableConfig,
      // shipTableConfig,
      isGas: null, // 是否是加气
      refundNum: 0, // 有退款的订单数
      refuseReasonList: {
        1: '已加油',
        2: '其他'
      }, // 拒绝退款原因列表
      refuseRefundOptions: {}, // （确认、拒绝）退款表单
      isRefuse: false, // 拒绝退款
      isConfirmRefund: false, // 确认退款
      isShowTicket: false,
      orderId: '', // 查看详情使用
      row: {}, // 详情页用于展示按钮状态的
      // flagsList: { // 订单状态列表
      //   0: '未支付',
      //   1: '已支付',
      //   4: '退款中',
      //   5: '已退款',
      //   6: '退款失败',
      //   7: '已取消'
      // },
      isAllLoading: false,
      loading: false,
      exportLoading: false,
      pageSizes: [20], // 每页展示选项
      orderData: [], // 订单列表
      dialogInvoice: false,
      activeRow: null, // 选择行
      orderOptions: {
        queryOrderType: 0,
        gasId: '', // 油站id
        orderPayFlag: '', // 订单状态
        phone: '', // 电话号码
        orderId: '', // 订单号
        gunNo: '', // 枪号
        guns: [], // 枪号多选
        oilNo: '', // 油号
        payType: '',
        payDtStart: '', // 支付起始时间
        payDtEnd: '', // 支付终止时间
        orderDtStart: '', // 下单起始时间
        orderDtEnd: '', // 下单终止时间
        invoiceFlags: undefined, // 开票方
        oilInvoiceStatus: undefined, // 开票状态
        orderSettleType: '', // 是否抖音结算方式
      },
      pageOptions: {
        pageIndex: 1, // 当前页
        pageSize: 20 // 每页个数
      },
      saveOptions:{},
      allTotal: 0,
      gasList: [], // 油站名称列表
      orderPayFlags: {}, // 订单状态列表
      oilNumList: {}, // 油号列表
      payTime: [], // 支付时间
      checkoutTime: [], //下单时间
      partyList: [], // 开票方列表
      invoiceStatusList: [], //开状态列表
      allNumber: {
        allGunAmount: '', // 交易总金额
        allPayAmount: '', // 实付总金额
        orderTotal: '', // 订单总单数
        allLitre: '', // 升数总和
      },
      address: {
        provinceCode: '',
        cityCode: '',
        countyCode: ''
      },
      showRealAmount: false,
      gasId: '',
      isShipStation: false, // 是否为船舶加油
      pontoonGasIds: [], // 船舶ID的list
      isShowTabelVerificateStatus: false,    //表格中是否展示核销状态
      setDisplayVisible: false,
      settingValue: [],
      reset: false,
      payTypeList: [],
      showInvoiceStatusButton: false, //控制是否展示开票状态筛选
      userPhone: '',
      showOilPayAmount: 0
    }
  },
  components: {
    orderDetail,
    card,
    addressSelect,
    ticket,
    confirmRefundDialog,
    rejectRefundDialog,
    applyRefundDialog
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      vm.$track.pageViewEvent('团油订单', '1621476214')
      vm.orderOptions = {
        queryOrderType: 0,
        gasId: '', // 油站id
        orderPayFlag: '', // 订单状态
        phone: '', // 电话号码
        orderId: '', // 订单号
        gunNo: '', // 枪号
        guns: [], // 枪号多选
        oilNo: '', // 油号
        payType: '',
        payDtStart: '', // 支付起始时间
        payDtEnd: '', // 支付终止时间
        orderDtStart: '', // 下单起始时间
        orderDtEnd: '', // 下单终止时间
        invoiceFlags: '', // 开票方
        oilInvoiceStatus: '', // 开票状态
        orderSettleType: '', // 是否抖音结算方式
      },
      vm.$refs.address.reset()
      vm.resetDate()
      vm.pageOptions.pageIndex = 1
      vm.pageOptions.pageSize = 20
      // 从工作台页面进来，同时是点击订单那按钮进来的,改变查询条件
      // if(from.name === 'workPlatform' && vm.saveInfo) {
      if(from.name === 'businessAnalysis' && vm.saveInfo) {
        vm.orderOptions.orderPayFlag = 4
        vm.orderOptions.orderDtStart = ''
        vm.orderOptions.orderDtEnd = ''
        vm.checkoutTime = []
      }
      // socket弹框消息跳转进来的，全部是退款中订单
      if (vm.$route.query.isRefund) {
        vm.orderOptions.orderPayFlag = 4
        vm.orderOptions.orderDtStart = ''
        vm.orderOptions.orderDtEnd = ''
        vm.checkoutTime = []
      }
      vm.saveOptions = {...vm.orderOptions}
      vm.pontoonGasIds = vm.userInfo.pontoonGasIds || []
      vm.whetherHasShip()
      // 设置初始化表格列
      vm.getPayTypeList()
      await vm.getShowOilPayAmount()
      vm.setInitTable()
      if(!vm.userInfo.company) vm.getInvoiceNum()
      // 从发票页跳转过来
      let userPhone = from.name === 'userApplyInvoice' ? sessionStorage.getItem('userPhone') : ''
      vm.userPhone = userPhone
      if (userPhone) {
        vm.orderOptions.orderDtStart = ''
        vm.orderOptions.orderDtEnd = ''
        vm.checkoutTime = []
      }
      vm.init()
      // vm.initRefundReason()
      vm.showRealAmountApi()
    })
  },
  computed: {
     ...mapState({
      userInfo: state => state.user.userInfo,
      saveInfo: state => state.saveCustomer.saveInfo,
      isKnowRefund: state => state.isRefund.isKnowRefund
    }),
    queryParams () {
      const orderOptionsCopy = JSON.parse(JSON.stringify(this.orderOptions))
      if (orderOptionsCopy.guns.length === this.optionsGunNo.length) {
        orderOptionsCopy.guns = ''
      } else {
        orderOptionsCopy.guns = orderOptionsCopy.guns.join(',')
      }
      return Object.assign({}, {...orderOptionsCopy, ...this.address, businessType: this.businessType})
    },
    isHongQi () {
      console.log('this.userInfo.gasId ', this.userInfo)
      const gasId = process.env.NODE_ENV === 'production' ? 'HQ000035980' : 'YF000147060'
      const companyId = process.env.NODE_ENV === 'production' ? 45240 : 2000704
      return this.userInfo.gasId === gasId || this.userInfo.companyId === companyId
    }
  },
  methods: {
    // 切换tab页
    tabChange () {
      this.initContent()
    },
    async getInvoiceNum () {
      try {
        const {code, result} = await getInvoiceNum()
        if (code !== 200) return
        this.invoiceNum = result
      } catch (error) {
        console.log(error)
      }
    },
    invoicing () {
      this.$track.clickEvent('团油订单页-「点击此处」按钮', '1641797176')
      this.$router.push({ path:'/invoice/userApplyInvoice' })
    },
    // 查询条件选择枪号
    handleChangeGun (data) {
      if (data[data.length - 1] === 'all') {
        this.orderOptions.guns = this.optionsGunNo.map(item => item.key)
      }
    },
    // 获取支付方式
    async getPayTypeList () {
      const { code, result } = await payTypeList()
      if (code !== 200) return
      this.payTypeList = result
    },
    // 展示真实金额
    async showRealAmountApi () {
      try {
        const {code, result} = await showRealAmount()
        if (code !== 200) return
        this.showRealAmount = result
      } catch (error) {
        console.log(error)
      }
    },
    // 获取需要退款的订单数量
    async getRefundNum () {
      try {
        const { code, result } = await getRefundNum()
        if (code !== 200) return
        this.refundNum = result
      } catch (error) {
        console.log(error.message)
      }
    },
    resetDate () {
      this.checkoutTime = [moment().format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD HH:mm:ss")]
      this.orderOptions.orderDtStart = moment().format("YYYY-MM-DD 00:00:00")
      this.orderOptions.orderDtEnd = moment().format("YYYY-MM-DD HH:mm:ss")
      this.payTime = []
      this.orderOptions.payDtStart = ''
      this.orderOptions.payDtEnd = ''
    },
    resetForm () {
      this.orderOptions = {
        queryOrderType: 0,
        gasId: '', // 油站id
        orderPayFlag: '', // 订单状态
        phone: '', // 电话号码
        orderId: '', // 订单号
        gunNo: '', // 枪号
        guns: [], // 枪号多选
        oilNo: '', // 油号
        payType: '',
        payDtStart: '', // 支付起始时间
        payDtEnd: '', // 支付终止时间
        orderDtStart: '', // 下单起始时间
        orderDtEnd: '', // 下单终止时间
        invoiceFlags: '', // 开票方
        oilInvoiceStatus: '', // 开票状态
        orderSettleType: '', // 是否抖音结算方式
      },
      this.userPhone = ''
      this.$refs.address.reset()
      this.resetDate()
      this.pageOptions.pageIndex = 1
      this.pageOptions.pageSize = 20
      this.initContent()
    },
    async getSum () { // 获取总数据
      let params
      if (this.userPhone) {
        params = { phone: this.userPhone, orderPayFlag: 1, ...this.pageOptions }
      } else {
        params = {...this.orderOptions, ...this.pageOptions, ...this.address, businessType: this.businessType}
        if (params.guns.length === this.optionsGunNo.length) {
          params.guns = ''
        } else {
          params.guns = params.guns.join(',')
        }
      }
      this.isAllLoading = true
      try {
        const { code, result } = await getSum(params)
        if (code !== 200) return
        this.allNumber = result
      } catch (error) {
        console.log(error.message)
      } finally {
        this.isAllLoading = false
      }
    },
    init () { // 初始化页面
      this.initQueryConditions()
      this.orderPageButtonList() // 获取tab按钮是否展示
      this.gasLicenceExpiry()
      this.gasInfoCheckNotice()
      this.violationRecordNotice()
    },
    initContent () { // 获取订单数据
      this.getRefundNum()
      this.queryOrderList()
      this.getSum()
    },
    initQueryConditions () { // 获取查询条件
      this.getQueryOrderType()
      this.getQueryGasList()
      this.getOilNumList()
      // this.initStatusList()
      this.getInvoiceSource()
    },
    handleSizeChange (val) {
      console.log(val) // 每页显示多少条改变时触发
    },
    handleCurrentChange (val) {
      this.pageOptions.pageIndex = val
      this.queryOrderList(false, true)
    },
    // 页面顶部立即处理按钮，调取列表接口，状态置位退款中
    handleRefundNow () {
      this.orderOptions.orderPayFlag = 4
      this.orderOptions.orderDtStart = ''
      this.orderOptions.orderDtEnd = ''
      this.checkoutTime = []
      this.queryOrderList()
      this.getSum()
    },
    query: _.throttle(function (type) { // 点击查询
      this.$track.clickEvent('团油订单查询', '1621000996')
      this.$track.clickEvent('团油订单订单状态', '1621001394', {
        tysj_trade_type: this.orderOptions.orderPayFlag
      })
      let { phone, orderId, gunNo } = this.orderOptions
      if (phone && !(/^1[3456789]\d{9}$/.test(phone))) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (orderId && !(/^[0-9a-zA-Z]*$/.test(orderId))) {
        this.$message.error('请输入正确的订单号')
        return
      }
      if (gunNo && !(/^[1-9]\d{0,1}$/.test(gunNo))) {
        this.$message.error('请输入正确的油枪号')
        return
      }
      if (type) {
        this.pageOptions.pageIndex = 1
        this.pageOptions.pageSize = 20
      }
      this.userPhone = ''
      this.queryOrderList(type)
      this.getSum()
    }, 1000),
    // 标记开票
    confirm (row) {
      this.dialogInvoice = true
      this.activeRow = row
    },
    async confirmInvoice () {
      try {
        const {code, message} = await confirmInvoice({ orderId: this.activeRow.orderId })
        if (code === 200) {
          this.$message.success('操作成功')
          this.$track.clickEvent('团油订单页-标记开票按钮', '1648796845')
          this.initContent()
          this.dialogInvoice = false
        } else if (code === 1000) {
          this.dialogInvoice = false
          this.$alert(message, '提示', {
            confirmButtonText: '确定'
          })
        }else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    revoke (orderId) {
      this.$confirm('是否撤销开票？撤销后该发票状态将被标记为未开票。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const {code, message} = await revokeInvoice({ orderId })
          if(code === 200) {
            this.$message.success('撤销成功')
            this.$track.clickEvent('团油订单页-撤销开票按钮', '1648796846')
            this.initContent()
          } else if (code === 1000) {
            this.$alert(message, '提示', {
              confirmButtonText: '确定'
            })
          } else {
            this.$message.error(message)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    goOrder () {
      this.dialogInvoice = false
      this.orderOptions = {
        queryOrderType: 0,
        gasId: '', // 油站id
        orderPayFlag: '', // 订单状态
        phone: '', // 电话号码
        orderId: '', // 订单号
        gunNo: '', // 枪号
        guns: [], // 枪号多选
        oilNo: '', // 油号
        payType: '',
        payDtStart: '', // 支付起始时间
        payDtEnd: '', // 支付终止时间
        orderDtStart: '', // 下单起始时间
        orderDtEnd: '', // 下单终止时间
        invoiceFlags: '', // 开票方
        oilInvoiceStatus: '', // 开票状态
        orderSettleType: '', // 是否抖音结算方式
      },
      this.checkoutTime = []
      this.userPhone = this.activeRow.phone
      this.getSum()
      this.queryOrderList()
      this.$track.clickEvent('标记开票弹窗-查看历史已支付订单按钮', '1648796844')
    },
    async queryOrderList (type, change) { // 获取订单列表
      if (change) {
        this.orderOptions = { ...this.saveOptions }
        // let { payDtStart, payDtEnd } = this.saveOptions
        // this.payTime = [payDtStart, payDtEnd]
        let { orderDtStart, orderDtEnd } = this.saveOptions
        this.checkoutTime = [orderDtStart, orderDtEnd]
      }
      this.loading = true
      let params = {...this.orderOptions, ...this.pageOptions, ...this.address, businessType: this.businessType}
      if (params.guns.length === this.optionsGunNo.length) {
        params.guns = ''
      } else {
        params.guns = params.guns.join(',')
      }
      if (this.userPhone) {
        params = { phone: this.userPhone, orderPayFlag: 1, ...this.pageOptions }
      }
      // 判断是否是加气的站, 商户调取接口，需要传gasId,否则默认给油站数据，油站调取接口不需要传参
      if (!this.userInfo.company) {
        this.getStationEnergyTypeApi()
      } else {
        this.getStationEnergyTypeApi({ gasId: params.gasId })
        this.setInitTable()
      }
      try {
        const { code, result, totalRow } = await getOrdersByPageNew(params)
        if (code !== 200) return
        this.whetherHasShip()
        if (type) this.saveOptions = {...this.orderOptions}
        const { list, isShowVerificateStatus } = result || {}
        this.orderData = list ? list : []
        this.isShowTabelVerificateStatus = isShowVerificateStatus || false   //表格是否展示核销状态
        this.allTotal = totalRow
      } catch (error) {
        console.log(error.message)
      } finally {
        this.loading = false
      }
    },
    // 判断当前油站是加气还是加油
    async getStationEnergyTypeApi (params) {
      try {
        const { code, result } = await getStationEnergyType(params)
        if(code !==200) return
        this.isGas = result
        this.tableConfig[this.findColumnIndex('oilNumName')].label = result === 2 ? '气号' : '油号'
        this.tableConfig[this.findColumnIndex('litre')].label = result === 2 ? '数量' : '升数'
        this.tableConfig[this.findColumnIndex('amountGun')].label = result === 2 ? '金额（元）' : '加油金额（元）'
      } catch (error) {
        console.log(error)
      }
    },
    onChangePayTime (val,model,startTime,endTime) {
      if(!val) {
        this.orderOptions[startTime] = ''
        this.orderOptions[endTime] = ''
        this[model] = []
        return
      }
      if((moment(val[1]).valueOf() - moment(val[0]).valueOf()) > 3600 * 1000 * 24 * 59) {
        this.orderOptions[startTime] = ''
        this.orderOptions[endTime] = ''
         this[model] = []
        this.$message.info('选择时间段不能超过60天')
        return
      }
      this.orderOptions[startTime] = val[0]
      this.orderOptions[endTime] = val[1]
    },
    async onExportExcel () {
      this.$track.clickEvent('团油订单导出', '1621011390')
      let length = this.orderData.length
      if (!length) {
        this.$message.error('导出excel为空，不能导出')
        return
      }
      this.exportLoading = true
      try {
        // this.orderOptions.guns = this.orderOptions.guns.join(',')
        const { code, result = {} } = await exportData({...this.orderOptions, ...this.address})
        if (code !== 200) return
        // const time = moment().format("YYYY-MM-DD")
        // const name = `订单列表_${time}`
        exportSearchList(result.file, result.fileName)
      } catch (error) {
        console.log(error.message)
      } finally {
        this.exportLoading = false
      }
    },
    async getQueryOrderType () { // 获取订单查询订单状态
      try {
        const { code, result } = await getQueryOrderType()
        if (code !== 200) return
        this.orderPayFlags = result || {}
      } catch (error) {
        console.log(error.message)
      }
    },
    async getQueryGasList () { // 获取订单查询油站信息
      try {
        const { code, result } = await getQueryGasList()
        if (code !== 200) return
        this.gasList = result || []
      } catch (error) {
        console.log(error.message)
      }
    },
    async getOilNumList () { // 获取油号列表
      try {
        const { code, result } = await getOilNumList()
        if (code !== 200) return
        this.oilNumList = result || []
      } catch (error) {
        console.log(error.message)
      }
    },
    async allGasGunOptioons () { // 获取枪号枚举
      try {
        const { code, result } = await allGasGunOptioons()
        if (code !== 200) return
        this.optionsGunNo = result || []
        this.orderOptions.guns = result.map(item => item.key)
        this.initContent()
      } catch (error) {
        console.log(error.message)
      }
    },
    async initStatusList () {
      try {
        const {code, result} = await getInvoiceStatus()
        if (code !== 200) return
        this.invoiceStatusList = Object.entries(result).map(([value, label]) => ({ label, value }))
      } catch (error) {
        console.log(error)
      }
    },
    async getInvoiceSource () {
      try {
        const {code, result} = await getInvoiceSource()
        if (code !== 200) return
        this.partyList = Object.entries(result).map(([value, label]) => ({ label, value }))
      } catch (error) {
        console.log(error)
      }
    },
    showDetail (row) { // 查看订单详情
      this.$track.clickEvent('团油订单详情', '1621001390')
      this.orderId = row.orderId
      this.$refs.orderDetail.initDia(row)
    },
    // 打开申请退款弹窗按钮
    showRefund (row, flag) {
      this.$refs.applyRefund.init(row.orderId, flag)
      this.row = row
    },
    // 申请退款组件传递的方法
    handleApply () {
      this.initContent()
    },
    // 补打小票
    showDoc (orderId) {
      this.orderId = orderId
      this.$refs.ticket.init()
    },
    // 补打小票组件传给的方法
    handleChangeTicket () {
      this.initContent()
    },
    // 详情页面里面嵌套组件修改状态，最外层的列表数据刷新
    handleDetailChange () {
      this.initContent()
    },
    // 确认退款弹框按钮
    confirmRefund (row, reason) {
      this.$refs.confirmRefundDialog.init(reason)
      this.row = row
    },
    // 确认退款弹框组件方法 最外层的列表数据刷新
    handleConfirmRefund () {
      this.initContent()
    },
    // 拒绝退款弹框按钮
    rejectRefund (row) {
      this.reset = true
      this.$nextTick(() => {
        this.$refs.rejectRefundDialog.init()
      })
      this.row = row
    },
    // 拒绝退款弹框组件方法
    handleRejectRefund () {
      this.initContent()
    },
    // 判断查询油站是否是船舶油站
    whetherHasShip () {
      if (!this.gasId) {
        // this.pontoonGasIds.length > 0 ? this.addTableColum() : this.removeTableColum()
        this.isShipStation = this.pontoonGasIds.length > 0
      } else {
        // this.pontoonGasIds.includes(this.gasId) ? this.addTableColum() : this.removeTableColum()
        this.isShipStation = this.pontoonGasIds.includes(this.gasId)
      }
    },
    // addTableColum () {
    //   if (this.findColumnIndex('ton') !== -1) return
    //   this.tableConfig.splice(this.findColumnIndex('oilNumName'), 0, this.shipTableConfig)
    // },
    // removeTableColum () {
    //   if (this.findColumnIndex('ton') === -1) return
    //   this.tableConfig.splice(this.findColumnIndex('ton'), 1)
    // },
    // 查找目标表格索引
    findColumnIndex (key) {
      return this.tableConfig.findIndex(item => item.prop === key)
    },
    // 初始化页面表格
    async setInitTable () {
      const column = await this.queryColumn()
      const columnList = column.filter(item => item.show).map(item => item.key)
      this.setTable(columnList)
    },
    // 查询表格展示顺序
    async queryColumn () {
      let params = { menuCode: this.menuCode }
      if (!this.userInfo.company) {
        params.gasId = this.userInfo.gasId
      } else {
        params.gasId = this.orderOptions.gasId
      }
      try {
        const { code, result } = await getColumn(params)
        if (code !== 200) return
        // 判断是否展示油品实付金额
        if (!this.showOilPayAmount) {
          result.splice(result.findIndex(item => item.key === 'onlyOilPayAmount'), 1)
        }
        return result.sort((a, b) => a.rank - b.rank)
      } catch (error) {
        console.log(error)
      }
    },
    // 自定义展示
    async setDisplay () {
      const columnData = await this.queryColumn()
      this.setDisplayVisible = true
      this.columnData = columnData.map(item => {
        if (item.optional === 0) item.disabled = true
        return item
      })
      this.settingValue = columnData.filter(item => item.show).map(item => item.key)
    },
    // 设置表格
    setTable (arr) {
      this.tableConfig = []
      let newConfig = [...arr, 'action'].map(item => tableConfig.find(key => key.prop === item)).filter(item => item)
      this.$nextTick(() => {
        this.tableConfig = newConfig
      })
    },
    cancelSetting () {
      this.setDisplayVisible = false
    },
    // 保存展示顺序
    async confirmSetting () {
      this.setTable(this.settingValue)
      this.columnData.forEach((item, index) => item.rank = index )
      try {
        const { code } = await saveColumn({ fieldInfoJson: JSON.stringify(this.columnData), gasId: this.userInfo.gasId, menuCode: 'tuanyouOrder' })
        this.$message({
          message: code === 200 ? '设置成功': '设置失败',
          type: code === 200 ? 'success': 'error'
        })
        this.cancelSetting()
      } catch (error) {
        console.log(error)
      }
    },
    // 穿梭框变化，更改数据排序
    setRightChange (val, action, keyList) {
      let sortList = action === 'right' ? val.filter(item => keyList.includes(item)) : keyList
      sortList.map(item => {
        const index = this.columnData.findIndex(i => i.key === item)
        if (index !== -1) {
          this.columnData[index].show = action === 'right' ? 1 : 0
          const row = this.columnData.splice(index, 1)
          this.columnData.push(...row)
        }
      })
    },
    // 恢复默认
    async useDefault () {
      try {
        let params = { menuCode: this.menuCode }
        if (!this.userInfo.company) {
          params.gasId = this.userInfo.gasId
        } else {
          params.gasId = this.orderOptions.gasId
        }
        const { code, result } = await getDefaultColumn(params)
        if (code !== 200) return
        if (!this.showOilPayAmount) {
          result.splice(result.findIndex(item => item.key === 'onlyOilPayAmount'), 1)
        }
        this.columnData = result.map(item => {
          if (item.optional === 0) item.disabled = true
          return item
        })
        this.settingValue = result.filter(item => item.show).map(item => item.key)
      } catch (error) {
        console.log(error)
      }
    },
    // 删除已选字段
    delSelected ({ key, optional }) {
      if (!optional) return
      this.settingValue.splice(this.settingValue.indexOf(key), 1)
      this.columnData.map(item => {
        if (item.key === key) {
          item.show = 0
        }
      })
    },
    // 判断上方tab栏按钮是否展示
    async orderPageButtonList () {
      try {
        const { code, result } = await orderPageButtonList()
        if (code !== 200) return
        // this.tabList[1].show = result.haveMotorcadeButton // 是否显示直供按钮
        this.tabList[1].show = result.haveEnterPriseButton // 是否显示企服按钮
        this.isShowguns = result.showGunNoSelectList
        if (this.isShowguns) {
          this.allGasGunOptioons()
        }
        this.showInvoiceStatusButton = result.showInvoiceStatusButton
      } catch (error) {
        console.log(error)
      }
    },
    // 查询三证是否过期
    async gasLicenceExpiry () {
      const { code, result } = await gasLicenceExpiryTips({ cache: 1 })
      if (code !== 200) return
      let arr1 = ['gasBottleCertificatesDefectTips', 'gasCertificatesDefectTips', 'hcLicenseDefectTips', 'productDefectTips']
      result.map(item => {
        if (item) {
        let gasId = item.gasId
          for (let key in item) {
            if (key !== 'gasId' && item[key]) {
              // 使用定时器，防止message信息重叠
              setTimeout(() => {
                const h = this.$createElement;
                this.$notify({
                  title: arr1.includes(key) ? '资质不全提醒' : '资质到期提醒',
                  message: h('p', {
                    style: 'display: flex; flex-direction: column;'
                  }, [
                    h('span', { style: 'color: #606266; padding-top: 6px' }, item[key]),
                    h('a',{
                      style: 'color: #3377FF; padding-top: 8px',
                      on: {
                        click: () => {
                          this.goToMore(gasId)
                        }, // 确定按钮的点击事件
                      },
                    }, "立即处理"),
                  ]),
                  duration: 4000
                })
              },50)
            }
          }
        }
      })
    },
    // 资质审核状态
    async gasInfoCheckNotice () {
      const { code, result } = await queryGasInfoCheckNotice()
      if (code !== 200) return
      result.map(item => {
        if (item) {
        let gasId = item.gasId
          setTimeout(() => {
            const h = this.$createElement
            this.$notify({
              title: item.title,
              message: h('p', {
                style: 'display: flex; flex-direction: column;'
              }, [
                h('span', { style: 'color: #606266; padding-top: 6px' }, item.content),
                h('a',{
                  style: 'color: #3377FF; padding-top: 8px',
                  on: {
                    click: () => {
                      this.goToMore(gasId)
                    }, // 确定按钮的点击事件
                  },
                }, item.buttonText),
              ]),
              duration: 4000
            })
          },50)
        }
      })
    },
    // 违规记录通知
    async violationRecordNotice () {
      const { code, result } = await violationRecordNotice()
      if (code !== 200) return
      result.map(item => {
        if (item) {
          setTimeout(() => {
            const h = this.$createElement
            this.$notify({
              title: item.title,
              message: h('p', {
                style: 'display: flex; flex-direction: column;'
              }, [
                h('span', { style: 'color: #606266; padding-top: 6px' }, item.content),
                h('a',{
                  style: 'color: #3377FF; padding-top: 8px',
                  on: {
                      click: this.goToNoticeMore // 确定按钮的点击事件
                  },
                }, item.buttonText),
              ]),
              duration: 4000
            })
          },50)
        }
      })
    },
    goToMore (gasId) {
      this.$router.push({
        path: '/gasStationManage/gasDetail',
        query: {
          type: 0,
          gasId,
          flag: true
        }
      })
    },
    // 违规记录
    goToNoticeMore () {
      this.$router.push({ path: '/ruleCenter/violation' })
    },
    async getShowOilPayAmount () {
      const { code, result } = await showRealPayAmount()
      if (code !== 200) return
      this.showOilPayAmount = result.showOilPayAmount
    }
  },
  beforeDestroy () {
    sessionStorage.removeItem('userPhone')
  }
}
</script>

<style lang="less" scoped>
@import url('./styles/orderList.less');
</style>
